import Service from '@/service/index.js';
import RegExpObj from '@/utils/regExp.js';
import { validateDate } from '@/utils/common.js';

export default {
  components: {
  },
  props: ['projectInfo', 'type'],
  data() {
    const validateCertificateNo = (rule, value, callback) => {
      if(!value) {
        callback(new Error('请输入统一社会信用代码或身份证号'));
      }
      if (value && value.length < 18) {
        callback(new Error('请输入正确的统一社会信用代码或身份证号'));
      } else {
        callback();
      }
    };
    const validateStartTime = (rule, value, callback) => {
      if(validateDate(value, this.totalForm.endTime)) {
        callback(new Error('结束日期不能早于开始日期'));
      } else {
        callback();
      }
    };
    const validateEndTime = (rule, value, callback) => {
      if(validateDate(this.totalForm.startTime, value)) {
        callback(new Error('结束日期不能早于开始日期'));
      } else {
        callback();
      }
    };
    return {
      plotTypeArr: [],
      totalFormArr: [
        {
          code: '1',
          value: '无争议'
        },
        {
          code: '2',
          value: '有争议'
        }
      ],
      typeArr: [],
      massifs: [
        {
          mobile: '',
          massifName: '',
          area: null,
          price: null,
          toEast: '',
          toWest: '',
          toSouth: '',
          toNorth: '',
          attachment: '',
          certificateNo: '',
          originalPurpose: '', // 原用途
          originalContractor: '' // 原承包人
        }
      ],
      totalForm: {
        sumArea: null,
        sumPrice: null,
        plotType: '',
        totalFormtype: '',
        startTime: '',
        endTime: ''
      },
      rules: {
        massifName: [
          { required: true, message: '请输入地块名称', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请输入面积', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' }
        ],
        originalPurpose: [
          { required: true, message: '请输入原用途', trigger: 'blur' }
        ],
        toEast: [
          { required: true, message: '请输入东至', trigger: 'blur' }
        ],
        toWest: [
          { required: true, message: '请输入西至', trigger: 'blur' }
        ],
        toSouth: [
          { required: true, message: '请输入南至', trigger: 'blur' }
        ],
        toNorth: [
          { required: true, message: '请输入北至', trigger: 'blur' }
        ],
        attachment: [
          { required: true, message: '请输入附属设施及其他情况', trigger: 'blur' }
        ],
        originalContractor: [
          { required: true, message: '请输入当前承包人', trigger: 'blur' }
        ],
        certificateNo: [
          { required: true, validator: validateCertificateNo, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: RegExpObj.phone, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      },
      totalFormRules: {
        sumPrice: [
          { required: true, validator: this.sumPriceValidate, trigger: 'blur' }
        ],
        startTime: [
          { required: false, validator: validateStartTime, trigger: 'change' }
        ],
        endTime: [
          { required: false, validator: validateEndTime, trigger: 'change' }
        ],
        plotType: [
          { required: true, message: '请选择地块类型', trigger: 'change' }
        ],
        totalFormtype: [
          { required: true, message: '请选择地块类型', trigger: 'change' }
        ]
      }
    };
  },
  watch: {
    projectInfo: {
      handler: function(){
        console.log(1);
        const assetsInfo = this.projectInfo && this.projectInfo.assetsInfo && JSON.parse(this.projectInfo.assetsInfo);
        const arr = [];
        if(assetsInfo) {
          assetsInfo.forEach(item => {
            // const obj = JSON.parse(item);
            const obj = typeof item === 'string' ? JSON.parse(item) : item;
            Object.keys(obj).forEach((key) => {
              obj[key] = String(obj[key]);
            });
            arr.push(obj);
          });
        }
        if (arr.length) {
          this.massifs = arr;
        }
        Object.keys(this.totalForm).forEach((key) => {
          if(this.projectInfo[key] === undefined) return;
          this.totalForm[key] = this.projectInfo && String(this.projectInfo[key]);
        });
        this.$emit('landTotalForm', { sumPrice: this.totalForm.sumPrice, count: this.massifs.length });
      },
      immediate: true
    }
  },
  created () {
    Service.getSelectList('MASSIF_TYPE').then(res => {
      if (res && res.code === '0') {
        this.typeArr = res.data;
      }
    });
    Service.getSelectList('BATCH_ASSETS_INFO_STATUS').then(res => {
      if (res && res.code === '0') {
        this.plotTypeArr = res.data;
      }
    });
  },
  methods: {
    priceVali(rule, value, callback){
      if(value === '' || value === null){
        callback(new Error('请输入价格'));
      } else if(value < 1 || value > 9999999.99){
        callback(new Error('请输入0-10000000以内的数字'));
      } else {
        callback();
      }
    },
    areaVali(rule, value, callback){
      if(value === '' || value === null){
        callback(new Error('请输入面积'));
      } else if(value < 0 || value > 99999.99){
        callback(new Error('请输入0-100000以内的数字'));
      } else {
        callback();
      }
    },
    // 总金额校验
    sumPriceValidate(rule, value, callback){
      if(value === '' || value === null){
        callback(new Error('请填写发包期限内的总金额'));
      } else if(Number(value) < 1 || Number(value) > 99999999) {
        callback(new Error('请输入1-99999999以内的数字'));
      } else {
        callback();
      }
    },
    clear(){
      // if( this.projectInfo.projectType === 3) return false;
      // console.log(this.projectInfo);
      this.massifs = [
        {
          mobile: '',
          massifName: '',
          area: null,
          price: null,
          toEast: '',
          toWest: '',
          toSouth: '',
          toNorth: '',
          attachment: '',
          certificateNo: '',
          originalPurpose: '', // 原用途
          originalContractor: '' // 原承包人
        }
      ];
      this.totalForm = {
        sumArea: null,
        sumPrice: null,
        currentPrice: null,
        plotType: '',
        totalFormtype: '',
        startTime: '',
        endTime: ''
      };
      // 清空红色必填标示
      if(this.$refs['waterForm']) {
        this.$refs['waterForm'].resetFields();
      }
    },
    addLand () {
      this.massifs.push({
        massifName: '',
        area: null,
        price: null,
        originalPurpose: '',
        toEast: '',
        toWest: '',
        toSouth: '',
        toNorth: '',
        attachment: '',
        certificateNo: '',
        originalContractor: ''
      });
    },
    deleteLand (index) {
      this.massifs.splice(index, 1);
      let sumArea = 0;
      this.massifs.forEach(item => {
        sumArea += Number(item.area);
      });
      this.totalForm.sumArea = sumArea.toFixed(2);

      let sumPrice = null;
      this.massifs.forEach(item => {
        sumPrice += Number(item.price);
      });
      this.totalForm.sumPrice = sumPrice.toFixed(2);
      this.$emit('landTotalForm', {sumPrice: this.totalForm.sumPrice, count: this.massifs.length});
    },
    changeArea (event, index) {
      if (!RegExpObj.num.test(this.massifs[index].area)) {
        return;
      }
      this.massifs[index].area = this.massifs[index].area && Number(this.massifs[index].area).toFixed(2);
      let num = 0;
      this.massifs.forEach(item => {
        num += Number(item.area);
      });
      this.totalForm.sumArea = num.toFixed(2);
    },
    changePrice (event, index) {
      if (!RegExpObj.num.test(this.massifs[index].price)) {
        return;
      }
      console.log(this.massifs[index].price, Number(this.massifs[index].price).toFixed(2));
      this.massifs[index].price = this.massifs[index].price && Number(this.massifs[index].price).toFixed(2);
      let num = null;
      this.massifs.forEach(item => {
        num += Number(item.price);
      });
      this.totalForm.sumPrice = num.toFixed(2);
      this.$emit('landTotalForm', {sumPrice: this.totalForm.sumPrice, count: this.massifs.length});
    },
    // 总金额改变
    changeSumPrice () {
      this.$emit('landTotalForm', {sumPrice: this.totalForm.sumPrice, count: this.massifs.length});
    },
    test() {
      return new Promise((resolve, reject) => {
        let num = 0;
        this.massifs.forEach((form, index) => {
          form.price = 0;
          this.$refs[`landForm${index}`][0].validate((valid) => {
            if (valid) {
              num ++;
            } else {
              reject();
            }
          });
        });
        if (num === this.massifs.length) {
          // 校验总金额
          this.$refs['totalForm'].validate((valid) => {
            if (valid) {
              this.massifsobj = {
                massifs: this.massifs,
                massifsInfo: this.totalForm
              };
              resolve({
                massifs: JSON.parse(JSON.stringify(this.massifsobj)),
                ...this.totalForm
              });
            } else {
              reject();
            }
          });
        } else {
          reject();
        }
      });
    }
  }
};
